import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_pillows_pillows: FaireCategoryEntity = {
  token: "cat_pillows-pillows",
  type: "category",
  name: "Throw pillows",
  level: 3,
  parentToken: "cat_home-decor-pillows",
  href: "/category/home-decor/throw-pillows-blankets/throw-pillows",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
